// /visualizations — real route (design doc's G2). The original
// (app/visualizations/page.tsx) is already a pure `'use client'` page with
// no server auth gate (design doc §1b: "no server auth gate today; the APIs
// 401" — it self-gates on `useUser()`/`isSignedIn` for the signed-out UI).
// The scaffold placed this under `_authed` already (routes/agents.tsx) —
// design doc §1b calls that "a strict improvement, not parity debt", so it's
// kept rather than moved to core.tsx. Default export from the page module
// mounts verbatim (it needs no server data at request time). Registered
// into the route tree from routes/agents.tsx.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authedRoute } from './guards';

const VisualizationsPage = lazy(() =>
  import('@/app/visualizations/page').then((m) => ({ default: m.default })),
);

export const visualizationsRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/visualizations',
  component: VisualizationsPage,
});
